@if (isListLayout && isConfigLoaded) {
  <div class="machine-list-container">
    @if (activeCategoryConfig) {
      <scitis-machine-list-category-container
        [category]="activeCategoryConfig"
        [currentLocation]="currentLocation"
        [currentMachineGroupId]="currentMachineGroupId"
        [isWindowContentVisible]="isWindowContentVisible"
        [organizationId]="organizationId"
        [rootMachineryGroupId]="rootMachineryGroupId"
        [whiteListedMachineryGroups]="whiteListedMachineryGroups"
        [refreshInterval]="refreshInterval"
        [userRole]="userRole"
        [store]="store">
      </scitis-machine-list-category-container>
    }
  </div>
}
